import { padStart } from "lodash-es"

export const CAMP_BRAND_BLUE = "#193479"

export const colorWithOpacity = (color: string, percent: number) => {
  const transparency = padStart(
    Math.round((percent / 100) * 256).toString(16),
    2,
    "0"
  )

  return [color, transparency].join("")
}

export const darkenHexColor = (color: string, percent: number) => {
  const hex = color.replace("#", "")
  const num = parseInt(hex, 16)
  const amt = Math.round(2.55 * percent)
  const R = (num >> 16) - amt
  const G = ((num >> 8) & 0x00ff) - amt
  const B = (num & 0x0000ff) - amt

  return (
    "#" +
    (
      0x1000000 +
      (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 +
      (G < 255 ? (G < 1 ? 0 : G) : 255) * 0x100 +
      (B < 255 ? (B < 1 ? 0 : B) : 255)
    )
      .toString(16)
      .slice(1)
  )
}
